// API
export const GET_INGESTER_PRODUCTS_ASSETS_API = '/ingester/products/:id/assets';

// QUERIES
export const QUERY_INGESTER_PRODUCTS_ASSETS = 'QUERY_INGESTER_PRODUCTS_ASSETS';
